import { render, staticRenderFns } from "./OtherConfiguration.vue?vue&type=template&id=e78a021a&scoped=true&"
import script from "./OtherConfiguration.vue?vue&type=script&lang=js&"
export * from "./OtherConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./OtherConfiguration.vue?vue&type=style&index=0&id=e78a021a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78a021a",
  null
  
)

export default component.exports